<template>
  <div class="question-box">
    <div class="question-title animate-target" v-animate-in>{{ title }}</div>
    <div class="question-desc animate-target" v-animate-in v-html="desc"></div>
    <div v-animate-in :class="'animate-target question-item '+node.checked" @click="isClick&&selected(index)" v-for="(node,index) in newItem" :key="index">
      <div class="option">{{ node.option }}</div>
      <div class="answer" v-html="node.answer"></div>
      <span class="show_icon_true"></span>
      <span class="show_icon_false"></span>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "QuestionBox",
  props:{
    title: {
      type:String,
      default:"",
    },
    desc: {
      type:String,
      default:""
    },
    items:{
      type:Array,
      default:()=>{
        return [];
      }
    },
    index:{
      type:String,
      default:null
    },
  },
  data(){
    return {
      newItem:[],
      isClick:false,//用来判断是否能够实现点击事件
    };
  },
  computed:{
    ...mapState(['is_click'])
  },
  mounted() {
    //将正确答案和全部答案列表通过vuex存储起来
    this.$store.commit('set_true_answer',this.index);
    this.$store.commit('set_question_list',this.newItem);

    this.isClick = true;
    this.$store.commit('set_is_click',true);

  },
  methods:{
    selected:function(index){
      if(this.is_click){
        this.newItem.forEach(function(item){
          item.checked = 'animate-enter';
        });
        this.newItem[index].checked = 'animate-enter active';

        this.$emit('selected', this.newItem[index].option)
      }else{
        return this.isClick=false
      }


    }
  },

  watch:{
    "items":{
      handler (newVal) {
        this.newItem = newVal;
        let newItems = new Array();
        for(let i=0;i<this.newItem.length;i++){
          let keycode = i+65;
          let option = String.fromCharCode(keycode);
          newItems.push({
            option:option,
            answer:this.newItem[i],
            checked:'',
            index:i
          });
        }
        this.newItem = newItems;
      },
      deep: true,
      immediate: true
    },
  },
}
</script>

<style scoped>

</style>
